import * as Highcharts from 'highcharts';
import { TProgressGaugeSimpleWidgetModelInputs } from '@monorepo/types';
import solidGauge from 'highcharts/modules/solid-gauge';

function getTitleText(value: number, label: string, fontSizeMultiplier: number): string {
  return `
					<div style="color: white; text-align: center;">
						<div>
							<span style="font-size: ${5 * fontSizeMultiplier}vh;">${value}</span> <span style="font-size: ${
    2 * fontSizeMultiplier
  }vh; font-weight: normal;">%</span>
						</div>
						<span style="font-size: ${3 * fontSizeMultiplier}vh; font-weight: normal;">${label}</span>
				</div>`;
}

export const PROGRESS_GAUGE_SIMPLE_WIDGET_MODEL = {
  createModel: (input?: TProgressGaugeSimpleWidgetModelInputs): Highcharts.Options => {
    solidGauge(Highcharts);
    if (!input) return {};
    return {
      chart: {
        type: 'solidgauge',
        backgroundColor: 'transparent',
        height: '75%',
      },
      title: {
        text: getTitleText(input.value, input.label, input.fontSizeMultiplier),
        verticalAlign: 'middle',
        align: 'center',
        useHTML: true,
        floating: true,
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [
          {
            outerRadius: '100%',
            innerRadius: `${input.innerCircleSizeInPercent}%`,
            backgroundColor: 'black',
            borderWidth: 0,
          },
        ],
      },
      tooltip: {
        enabled: false,
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false,
          },
          linecap: 'round',
          stickyTracking: false,
          rounded: input.borderStyle === 'SHARP' ? false : true,
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          type: 'solidgauge',
          data: [
            {
              radius: '100%',
              innerRadius: `${input.innerCircleSizeInPercent}%`,
              color: input.arcColor,
              y: input.value,
            },
          ],
        },
      ],
    };
  },
};
